import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { ForgotPasswordComponent } from "./components/forgot-password.component";

const routes: Routes = [
  {
    path: "esqueceu-a-senha",
    component: ForgotPasswordComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ForgotPasswordRoutingModule {}
